import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-reinforce-fix"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<g class=\"\"><path d=\"M39.65,17.0601V19.1301H4.35001V17.0601H39.66M40.9,15.8101H3.10001V20.3801H40.91V15.8101H40.9Z\" class=\"icon-fi--filled\"></path><path d=\"M33.71,25.45H10.29\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></path><path d=\"M8.77,27.57H5.22L6.99,24.27L8.77,27.57Z\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></path><path d=\"M38.87,27.57H35.32L37.09,24.27L38.87,27.57Z\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></path></g>", 1)
  ]), 16))
}
export default { render: render }